import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col
} from "reactstrap";
import CardInfo from "./card-info";
class SeccionDatosTematica extends React.Component {
  render() {
    let { param, data } = this.props,
      me = this;
    data = data || [];
    param = param || "";
    switch (param) {
      case "01":
        return me.renderTematica01(data);
      case "02":
        return me.renderTematica02(data);
      case "03":
        return me.renderTematica03(data);
      case "04":
        return me.renderTematica04(data);
      case "05":
        return me.renderTematica05(data);
      case "06":
        return me.renderTematica06(data);
      case "07":
        return me.renderTematica07(data);
      case "08":
        return me.renderTematica08(data);
      case "09":
        return me.renderTematica09(data);
      case "10":
        return me.renderTematica10(data);
      case "11":
        return me.renderTematica11(data);
      case "12":
        return me.renderTematica12(data);
      case "13":
        return me.renderTematica13(data);
      default:
        return me.renderDefault();
    }
  }
  renderDefault() {
    return (
      <Col xs={12} sm={12} md={6} xl={6}>
        <Card className="card-border-line">
          <CardHeader>
            <CardTitle>
              <div className="h5 text-primary">
                <i className="icon-datos_basicos" /> Datos básicos
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row></Row>
          </CardBody>
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
              <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row></Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica01(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
             <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica02(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica03(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica04(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica05(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica06(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica07(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica08(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica09(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica10(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica11(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica12(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
  renderTematica13(data) {
    return (
      <Col xs={12} sm={12} md={12} xl={12}>
        <Card className="card-border-line">
          <CardHeader className="card-header-bottom-line">
            <CardTitle>
            <div className="h5 card-sinia__title_default ">
                Principales cifras
              </div>
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Row className="pre-scrollable">
              {data.map((item, index) => (
                <Col key={index} xs={12} sm={12} md={6} xl={6}>
                  <CardInfo item={item} />
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    );
  }
}
export default SeccionDatosTematica;
